module.exports = __webpack_public_path__ + "static/media/ios-information.1acfdf21.svg";